"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitChar = "・";

exports.splitPath = function (pathKey) {
  return pathKey.split(exports.splitChar);
};

exports.joinPath = function (path) {
  return path.join(exports.splitChar);
};

exports.isPromise = function (x) {
  return x instanceof Promise;
};

exports.syncIfPossible = function () {
  var funcs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    funcs[_i] = arguments[_i];
  }

  return function (arg) {
    if (funcs.length === 0) {
      return arg;
    }

    var first = funcs[0],
        rest = funcs.slice(1);
    var ret = first(arg);

    if (exports.isPromise(ret)) {
      return ret.then(function (a) {
        return exports.syncIfPossible.apply(void 0, rest)(a);
      });
    } else {
      return exports.syncIfPossible.apply(void 0, rest)(ret);
    }
  };
};